import styled from 'styled-components';
import media from 'styled-media-query';

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  /* background-color: rgba(0,0,0,0.3); */
  position: relative;
  overflow: scroll;
`;

export const SiteContent = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  /* width: 100%; */
  overflow: auto;

  &:focus {
    outline: none;
  }
`;

export const Container = styled.div`
  /* min-height: 100vh; */
  /*display: flex;*/
  /*flex-direction: column;*/
  /* justify-content: center; */
  /* align-items: center; */
  width: 100%;
  /* max-width: var(--width-container); */
  /* margin: 0 auto; */
  /* padding: calc(var(--space) * 1.3); */

`;

// ${media.greaterThan('large')`
//   padding: calc(var(--space)*1.3) var(--space-sm);
// `}
